module.exports = __webpack_public_path__ + "static/media/31.f9df502a.png";